import { render, staticRenderFns } from "./PhonolEnvs.vue?vue&type=template&id=066ac0c1&scoped=true&"
import script from "./PhonolEnvs.vue?vue&type=script&lang=js&"
export * from "./PhonolEnvs.vue?vue&type=script&lang=js&"
import style0 from "./PhonolEnvs.vue?vue&type=style&index=0&id=066ac0c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ac0c1",
  null
  
)

export default component.exports